export default __webpack_public_path__ + "static/media/Set's Power.b7e8d7e5.jpg";